module.exports = __webpack_public_path__ + "static/img/20260905-05.a10dfde.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/20260905-05.webp
// module id = sf3/
// module chunks = 1